import React from 'react';
import { Stack } from '@mui/material';
import ThoughtSpotIntegration from './ThoughtspotIntegration';

/**
 * RA-2133 built the page (route, nav item, permission gate); RA-2135 wires the liveboard in.
 *
 * Deliberately the twin of `./DepartmentMetrics.tsx`: same frame, same embed component, only the
 * consumer differs. The facility selector, search and page chrome come from the dashboard layout
 * this route is mounted under, and `ThoughtSpotIntegration` applies the selected facility as a
 * runtime filter — so facility filtering matches Department Metrics by construction.
 */
const MdsMetrics: React.FC = () => {
  return (
    <Stack
      pt={2}
      bgcolor={'#F6F8FA'}
      sx={{ width: '100%', height: '100%', overflowY: 'hidden' }}
    >
      <ThoughtSpotIntegration who="mds" />
    </Stack>
  );
};

export default MdsMetrics;
